import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
import SelectOptions from 'general/constants/SelectOptions'
import {
  convertDate,
  findObjectInArray,
  padNumberWithZeros,
} from 'general/utils/Utils'

export const getColumns = () => {
  return [
    {
      name: 'Số chứng từ',
      width: '200px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.numberDocument}
          </p>
        )
      },
    },
    {
      name: 'Họ và tên',
      width: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row?.taxpayersName}
          </p>
        )
      },
    },
    {
      name: 'Ngày lập',
      width: '200px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row.createDate
              ? convertDate(row.createDate, 'DD/MM/YYYY HH:mm:ss')
              : ''}
          </p>
        )
      },
    },
    {
      name: 'Thời gian',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {row.incomeStartMonth == row.lastIncomeMonth
              ? `${padNumberWithZeros(row?.incomeStartMonth, 2)}/${row?.incomeYear}`
              : `${padNumberWithZeros(row?.incomeStartMonth, 2)} - ${padNumberWithZeros(row?.lastIncomeMonth, 2)}/${row?.incomeYear}`}
          </p>
        )
      },
    },
    {
      name: 'Ký hiệu',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 mr-4"
          >
            {`${row?.templatePaper?.symbolCode}/${row?.templatePaper?.symbolYear?.toString()?.slice(-2)}${row?.templatePaper?.symbolType}`}
          </p>
        )
      },
    },
    {
      name: 'Trạng thái',
      cell: (row) => {
        const constStatus = findObjectInArray(
          SelectOptions.listStatusAccountingDocuments,
          'value',
          row.status,
        )
        return (
          <div className="left-cell">
            <SpanNotYetReleasedTd
              color={constStatus?.color}
              backGroundColor={constStatus?.backGroundColor}
            >
              {constStatus?.label}
            </SpanNotYetReleasedTd>
          </div>
        )
      },
    },
  ]
}
